import { render, staticRenderFns } from "./WholesalerDetails.vue?vue&type=template&id=37176d0d&scoped=true&"
import script from "./WholesalerDetails.vue?vue&type=script&lang=js&"
export * from "./WholesalerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37176d0d",
  null
  
)

export default component.exports